export enum PpeType {
    Respiratory = 0,
    Noise = 1,
    Other = 2,
    Gas = 3,
    Psychological = 4,
}